import { ACSKey, ACSKeyData } from './ACSTypes';

export class ACSCacheUtils {
  public static isStringifiedACSKey(key: string): key is ACSKey {
    return /(.*)(_T:)(.*)(_I:)(.*)/.test(key);
  }

  public static createKeyData(
    party: string,
    templateId?: string,
    interfaceId?: string,
  ): ACSKeyData {
    return { party, templateId, interfaceId };
  }

  public static keyDataToString(key: ACSKeyData): ACSKey {
    return `${key.party ? key.party : 'ANY'}_T:${key.templateId ?? '()'}_I:${key.interfaceId ?? '()'}` as ACSKey;
  }
}
